import RoseIconImg from '../../assets/images/rose-icon.png';

export default function RoseIcon() {
  return <img src={RoseIconImg} height='17' width='17' />;
}
